import React from "react";
import Gallery from 'react-grid-gallery';

// reactstrap components
import {
  Button,
  Label,
  FormGroup,
  Input,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";

import DemoFooter from "components/Footers/DemoFooter.js";

const AboutUs = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("landing-page");
    return function cleanup() {
      document.body.classList.remove("landing-page");
    };
  });

  const IMAGES =
[{
    src: require("assets/img/newgallery/ucon1.JPG"),
    thumbnail: require("assets/img/newgallery/ucon1.JPG"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    
},
{
  src: require("assets/img/newgallery/ucon2.JPG"),
  thumbnail: require("assets/img/newgallery/ucon2.JPG"),
  thumbnailWidth: 320,
  thumbnailHeight: 174,
  },
  {
    src: require("assets/img/newgallery/ucon3.JPG"),
    thumbnail: require("assets/img/newgallery/ucon3.JPG"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    },
    {
      src: require("assets/img/newgallery/ucon4.JPG"),
      thumbnail: require("assets/img/newgallery/ucon4.JPG"),
      thumbnailWidth: 320,
      thumbnailHeight: 174,
      },
      {
        src: require("assets/img/newgallery/ucon5.JPG"),
        thumbnail: require("assets/img/newgallery/ucon3.JPG"),
        thumbnailWidth: 320,
        thumbnailHeight: 174,
        },
        {
          src: require("assets/img/newgallery/ucon6.JPG"),
          thumbnail: require("assets/img/newgallery/ucon4.JPG"),
          thumbnailWidth: 320,
          thumbnailHeight: 174,
          },
          {
            src: require("assets/img/newgallery/ucon13.JPG"),
            thumbnail: require("assets/img/newgallery/ucon13.JPG"),
            thumbnailWidth: 320,
            thumbnailHeight: 174,
            }


]
const IMAGES2 =
[{
    src: require("assets/img/newgallery/ucon7.JPG"),
    thumbnail: require("assets/img/newgallery/ucon7.JPG"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    
},
{
  src: require("assets/img/newgallery/ucon8.JPG"),
  thumbnail: require("assets/img/newgallery/ucon8.JPG"),
  thumbnailWidth: 320,
  thumbnailHeight: 174,
  },
  {
    src: require("assets/img/newgallery/ucon9.JPG"),
    thumbnail: require("assets/img/newgallery/ucon9.JPG"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    },
    {
      src: require("assets/img/newgallery/ucon10.JPG"),
      thumbnail: require("assets/img/newgallery/ucon10.JPG"),
      thumbnailWidth: 320,
      thumbnailHeight: 174,
      },
      {
        src: require("assets/img/newgallery/ucon11.JPG"),
        thumbnail: require("assets/img/newgallery/ucon11.JPG"),
        thumbnailWidth: 320,
        thumbnailHeight: 174,
        },
        {
          src: require("assets/img/newgallery/ucon12.JPG"),
          thumbnail: require("assets/img/newgallery/ucon12.JPG"),
          thumbnailWidth: 320,
          thumbnailHeight: 174,
          },
          {
            src: require("assets/img/newgallery/ucon14.JPG"),
            thumbnail: require("assets/img/newgallery/ucon14.JPG"),
            thumbnailWidth: 320,
            thumbnailHeight: 174,
            }

]
const IMAGES3 =
[{
    src: require("assets/img/newgallery/vis1.jpeg"),
    thumbnail: require("assets/img/newgallery/vis1.jpeg"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    
},
{
  src: require("assets/img/newgallery/vis2.jpeg"),
  thumbnail: require("assets/img/newgallery/vis2.jpeg"),
  thumbnailWidth: 320,
  thumbnailHeight: 174,
  },
  {
    src: require("assets/img/newgallery/vis3.jpeg"),
    thumbnail: require("assets/img/newgallery/vis3.jpeg"),
    thumbnailWidth: 320,
    thumbnailHeight: 174,
    },
    {
      src: require("assets/img/newgallery/vis4.jpeg"),
      thumbnail: require("assets/img/newgallery/vis4.jpeg"),
      thumbnailWidth: 320,
      thumbnailHeight: 174,
      },
      {
        src: require("assets/img/newgallery/vis5.jpeg"),
        thumbnail: require("assets/img/newgallery/vis5.jpeg"),
        thumbnailWidth: 320,
        thumbnailHeight: 174,
        },
        {
          src: require("assets/img/newgallery/vis6.jpeg"),
          thumbnail: require("assets/img/newgallery/vis6.jpeg"),
          thumbnailWidth: 320,
          thumbnailHeight: 174,
          },
          {
            src: require("assets/img/newgallery/vis7.jpeg"),
            thumbnail: require("assets/img/newgallery/vis7.jpeg"),
            thumbnailWidth: 320,
            thumbnailHeight: 174,
            },
            {
              src: require("assets/img/newgallery/vis8.jpeg"),
              thumbnail: require("assets/img/newgallery/vis8.jpeg"),
              thumbnailWidth: 320,
              thumbnailHeight: 174,
              },
              {
                src: require("assets/img/newgallery/vis9.jpeg"),
                thumbnail: require("assets/img/newgallery/vis9.jpeg"),
                thumbnailWidth: 320,
                thumbnailHeight: 174,
                }
                ,
                {
                  src: require("assets/img/newgallery/vis10.jpeg"),
                  thumbnail: require("assets/img/newgallery/vis10.jpeg"),
                  thumbnailWidth: 320,
                  thumbnailHeight: 174,
                  },
                  {
                    src: require("assets/img/newgallery/vis11.jpeg"),
                    thumbnail: require("assets/img/newgallery/vis11.jpeg"),
                    thumbnailWidth: 320,
                    thumbnailHeight: 174,
                    }
                    ,
                    {
                      src: require("assets/img/newgallery/vis12.jpeg"),
                      thumbnail: require("assets/img/newgallery/vis12.jpeg"),
                      thumbnailWidth: 320,
                      thumbnailHeight: 174,
                      },
                      {
                        src: require("assets/img/newgallery/vis13.jpeg"),
                        thumbnail: require("assets/img/newgallery/vis13.jpeg"),
                        thumbnailWidth: 320,
                        thumbnailHeight: 174,
                        }
                        ,
                        {
                          src: require("assets/img/newgallery/vis14.jpeg"),
                          thumbnail: require("assets/img/newgallery/vis14.jpeg"),
                          thumbnailWidth: 320,
                          thumbnailHeight: 174,
                          },
                          {
                            src: require("assets/img/newgallery/vis15.jpeg"),
                            thumbnail: require("assets/img/newgallery/vis15.jpeg"),
                            thumbnailWidth: 320,
                            thumbnailHeight: 174,
                            }
                            ,
                            {
                              src: require("assets/img/newgallery/vis16.jpeg"),
                              thumbnail: require("assets/img/newgallery/vis16.jpeg"),
                              thumbnailWidth: 320,
                              thumbnailHeight: 174,
                              },
                              {
                                src: require("assets/img/newgallery/vis17.jpeg"),
                                thumbnail: require("assets/img/newgallery/vis17.jpeg"),
                                thumbnailWidth: 320,
                                thumbnailHeight: 174,
                                }
                                ,
                              {
                                src: require("assets/img/newgallery/vis18.jpeg"),
                                thumbnail: require("assets/img/newgallery/vis18.jpeg"),
                                thumbnailWidth: 320,
                                thumbnailHeight: 174,
                                }
                               
                                                            

]


  return (
    <>
      <div className="about-us section" >
        <div
          style={{
            //backgroundImage: "url(" + require("assets/img/bg.png") + ")",
            backgroundColor:"#3E3C3D",
            
          }}
          className="page-bg"
        >
          <ExamplesNavbar notHome={true} />
          {/* <div className="section about-us"> */}
          <Container>
            <Row>
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/gate@2x.png") + ")",
                }}
                className="about-image"
              />
              <Col lg={6} >
                <br></br>
                <h2 className="title text-white ">Where we are  <hr style={{color:"#000000"}}/></h2>
                
                
                <div className="detail text-white">
                
                  Meraj Housing society is a project owned<br/> by the Directors of
                  Virk Group of<br/> Industries, which has developed its name<br/> in the
                  filed of manufacturing and <br/>customer service since 1995.
                </div>
                <Gallery images={IMAGES}/>
              </Col>
            </Row>

            <Row className="my-5" >
              <Col
                lg={12}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/gate@2x.png") + ")",
                }}
                className="about-image"
              />
              <Col lg={12} >
              <h3 className="title  text-white">
              <br/> Working on Full Swing <hr/></h3>
                 
                <div className="detail text-white">
                  The society is ideally situated few feet<br/> away from the newly
                  laid motorway M11,<br/> interconnecting the entire district to the<br/>
                  nearby cities very conveniently. The prime<br/> location will be
                  highly favorable for the <br/>residents for hassle free travelling,<br/>
                  avoiding the crowded city highways thus<br/> saving the travel time
                  and improving their<br/> quality of life.
                </div>
                
              </Col>
              <Col lg={12} >
              <Gallery images={IMAGES2}/>
              </Col>

            </Row>

            <Row className="my-6" >
            <Col
                lg={6}
                style={{
                  backgroundImage:
                    "url(" + require("assets/img/gate@2x.png") + ")",
                    backgroundColor:"#3E3C3D"
                }}
                className="about-image"
              />
              <Col lg={6}>
                <div className="detail text-white" >
                  <h3><br/>Our Vision <hr/></h3>
                  Our infrastructure is meticulously planned<br/> and executed by the
                  renowned architects<br/> and designers inspired by the modern<br/>
                  minimalist trend, highlighting sleek and<br/> clean exteriors in a
                  clean and green <br/>environment. Our careful planning’s are<br/>
                  further lead by skilled professionals <br/>working tirelessly to
                  visualize the dream.
                </div>
                <Gallery images={IMAGES3}/>
              </Col>
              
            </Row>

            
            
          </Container>
          {/* </div> */}
          <div
          className={"footer-logo-section content-center"}style={{backgroundColor:"#000000"}}
        >
          <img
            className="footer-image"
            src={require("assets/img/logo@2x.png")}
          />
          
        </div>
         
          { <DemoFooter/> }
        </div>
      </div>
    </>
  );
};

export default AboutUs;
